import EN from '../EN.json';
import FR from '../FR.json';

export const defaultLocale = 'en-US';
export const localeEn = 'en-US';
export const localeFr = 'fr-CA';

export const pages = {
  HOME: '/'
};

export const replace = str =>
  str && str.replace(/[ /]/g, '_').replace(/[()]/g, '');

export const isAbsoluteUrl = url =>
  url.indexOf('://') > 0 || url.indexOf('//') === 0;

export const getUrlWithoutLocale = locale => url =>
  (url && url.slice(locale.length + 2)) || pages.HOME;

export const addLocale = locale => url =>
  isAbsoluteUrl(url) ? url : `/${locale}${url}`;

export const getPathVariables = pathname =>
  pathname.substr(1, pathname.length).split('/');

export const getLocale = () => {
  return getPathVariables(window.location.pathname)[0];
};

export const getLocalizedStrings = () => {
  const locale = getPathVariables(window.location.pathname)[0];
  const localizedStrings = (locale || localeEn) === localeEn ? EN : FR;
  return localizedStrings;
};
